import { ThunkMiddleware, configureStore } from '@reduxjs/toolkit';
import { myLanesApi, companyApi } from './features/myLanes/state';
import { setupListeners } from '@reduxjs/toolkit/query';
import rootReducer from './combinedReducers';
import { ryanTransApi, milesServiceApi } from './features/findLoads/state';
import quotingApi from './features/quoting/quotingState';
import permissionsApi from './features/findLoads/permissionsState';
import feautureFlagApi from './state/featureFlagState.';

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat(
      myLanesApi.middleware as ThunkMiddleware,
      companyApi.middleware as ThunkMiddleware,
      ryanTransApi.middleware as ThunkMiddleware,
      quotingApi.middleware as ThunkMiddleware,
      milesServiceApi.middleware as ThunkMiddleware,
      permissionsApi.middleware as ThunkMiddleware,
      feautureFlagApi.middleware as ThunkMiddleware
    ),
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

setupListeners(store.dispatch);

export default store;
